import Dialog, { DialogContainer, DialogTitle, DialogContent, DialogBtnGroup } from 'components/Dialog';

const BlockNotConnectedDialog = ({ onConfirm }: { onConfirm: () => void }) => {
  return (
    <Dialog>
      <DialogContainer maxWidth={440}>
        <DialogTitle>블록이 연결되지 않았어요</DialogTitle>
        <DialogContent>
          {'연결되지 않은 블록이 존재해요\n이대로 저장하면 의도하지 않은 소스코드를 얻으실 수 있어요'}
        </DialogContent>
        <DialogBtnGroup cancelText="취소" confirmText="저장하기" onConfirm={onConfirm} />
      </DialogContainer>
    </Dialog>
  );
};

export default BlockNotConnectedDialog;
